import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Home } from './pages/Home';
import { AboutUs } from './pages/AboutUs';
import { MarketProducts } from './pages/MarketProducts';
import { Technology } from './pages/Technology';
import { Contact } from './pages/Contact';
import { SmoothScroll } from './components/SmoothScroll';
import { PageLoader } from './components/PageLoader';
import { ScrollToTop } from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <PageLoader />
      <SmoothScroll />
      <div className="min-h-screen bg-background font-instrument text-text-main relative">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/products" element={<MarketProducts />} />
          <Route path="/technology" element={<Technology />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
